import { useGlobalModal } from "context/GlobalModalContext";
import {
    DELETE_ALL_LDSU_MESSAGE,
    DELETE_ALL_LDSUS_WITH_BUS_MESSAGE,
    DELETE_MULTIPLE_LDSU_MESSAGE,
    DELETE_MULTIPLE_LDSUS_WITH_BUS_MESSAGE,
} from "constant/messages";

export const useDeleteLdsuModal = () => {
    const globalModal = useGlobalModal();

    const openModal = ({
        onConfirm,
        modelData,
    }: {
        onConfirm: () => Promise<void>;
        modelData: {
            itemLength?: number;
            busNumber: number | null;
            isDeleteAll: boolean;
        };
    }) => {
        const {
            itemLength = 0,
            isDeleteAll = false,
            busNumber = null,
        } = modelData;

        const modalTitle = "Delete LDSUs?";
        let modalPrompt = "";
        if (isDeleteAll) {
            modalPrompt = Number.isInteger(busNumber)
                ? DELETE_ALL_LDSUS_WITH_BUS_MESSAGE.fill({ busNumber })
                : DELETE_ALL_LDSU_MESSAGE;
        } else {
            modalPrompt = Number.isInteger(busNumber)
                ? DELETE_MULTIPLE_LDSUS_WITH_BUS_MESSAGE.fill({
                      length: itemLength,
                      busNumber,
                  })
                : DELETE_MULTIPLE_LDSU_MESSAGE.fill({ length: itemLength });
        }

        const modalContent = `${modalPrompt} This will delete associated Sensors and Actuators.`;

        globalModal.showModal({
            key: "delete_ldsu_modal",
            modalType: "dlt",
            modalContent,
            modalTitle,
            deleteFunction: async () => {
                await onConfirm();
                globalModal.setModalShow(false);
            },
        });
    };

    return {
        openModal,
    };
};
